import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken'

import {
    GET_ACCESSORY_PURCHASE,
    GET_ALL_ACCESSORY_PURCHASES,
    GET_ACCESSORY_PURCHASE_REQUEST,
    CREATE_ACCESSORY_PURCHASE,
    UPDATE_ACCESSORY_PURCHASE,
    DELETE_ACCESSORY_PURCHASE,
    CLEAR_ACCESSORY_PURCHASE
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all Accessory Purchases
export const getAccessoryPurchases = (page = 1, limit = 10) => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_ACCESSORY_PURCHASE_REQUEST,
        payload: true
    });
    
    try {
        const res =  await axios.get(`${API_URL}/accessory-purchase/all?page=${page}&limit=${limit}`);

        if(res.data.success){            
            dispatch({
                type : GET_ALL_ACCESSORY_PURCHASES,
                payload: res.data.data
            });
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch Accessory Purchases', 'danger'));
    }
}

// Get a single Accessory Purchase
export const getAccessoryPurchase = id => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    dispatch({
        type : GET_ACCESSORY_PURCHASE_REQUEST,
        payload: true
    });
    try {
        const res =  await axios.get(`${API_URL}/accessory-purchase/${id}`);
  
        if(res.data.success){  
            dispatch({
                type : GET_ACCESSORY_PURCHASE,
                payload: res.data
            });
            dispatch( setAlert('Successfully fetched Accessory Purchase details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get Accessory Purchase details', 'danger'));
    }
};

// Add a new Accessory Purchase
export const addAccessoryPurchase = formData => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
  
    try {
        const res =  await axios.post(`${API_URL}/accessory-purchase/`, formData, config);
        if(res.data.success){            
            dispatch({
                type: CREATE_ACCESSORY_PURCHASE,
                payload: res.data
            });
            // Also set the current accessory purchase for navigation
            dispatch({
                type: GET_ACCESSORY_PURCHASE,
                payload: res.data
            });
            dispatch(getAccessoryPurchases());
            dispatch(setAlert('Successfully added accessory purchase', 'success'));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }      
    } catch (err) {
        dispatch( setAlert('Error: Failed to add accessory purchase', 'danger') );
    }
};

// Update an Accessory Purchase
export const updateAccessoryPurchase = (id, formData) => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };  
    try {
        const res =  await axios.put(`${API_URL}/accessory-purchase/${id}`, formData, config);
        if(res.data.success){ 
            dispatch({
                type: UPDATE_ACCESSORY_PURCHASE,
                payload: res.data
            });
            dispatch(setAlert('Accessory Purchase Updated', 'success'));
            dispatch(getAccessoryPurchases());
            dispatch(getAccessoryPurchase(id));
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }      
    } catch (err) {
        dispatch( setAlert('Error: Failed to update accessory purchase', 'danger') );
    }
};

// Delete Accessory Purchase
export const deleteAccessoryPurchase = (accessoryPurchaseId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.delete(`${API_URL}/accessory-purchase/${accessoryPurchaseId}`, config);
        
        if (res.data.success) {
            dispatch({
                type: DELETE_ACCESSORY_PURCHASE,
                payload: accessoryPurchaseId
            });
            dispatch(setAlert('Accessory Purchase deleted successfully', 'success'));
            // Refresh the accessory purchases list
            dispatch(getAccessoryPurchases());
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete accessory purchase', 'danger'));
    }
};

// Clear Accessory Purchase
export const clearAccessoryPurchase = () => dispatch => {
    dispatch({
        type: CLEAR_ACCESSORY_PURCHASE,
        payload: null
    });
};
